import annIcon from '@assets/image/Icons/ann.svg';
import timeIcon from '@assets/image/Icons/time.svg';
import userIcon from '@assets/image/Icons/user.svg';
import { Col, Divider, Popover, Row } from 'antd';
import './index.scss';
const noticeStatus: any = {
  6: { color: '#302300', backgroundColor: '#FFF4D5', text: '重复' },
  3: { color: '#00346C', backgroundColor: '#EAF7FF', text: '待销售确认' },
  5: { color: '#606A76', backgroundColor: '#ECF0F4', text: '不相关' },
  2: {
    color: '#500808',
    backgroundColor: '#FDF0F0',
    text: `待Sector处理`
  },
  1: { color: '#500808', backgroundColor: '#FDF0F0', text: '待Admin处理' },
  4: { color: '#09271E', backgroundColor: '#E5F9F3', text: '完成确认' }
};
export const useInfoHead = ({ details = {} }: any) => {
  const { color, backgroundColor } = noticeStatus[details.noticeStatus] || {};

  const infoHeadComponent = (
    <div className="pc-infoHead-layout">
      <div className="pc-infoHead-alignFlex">
        <div className="pc-infoHead-name">{details.noticeName}</div>
        <Row className="pc-infoHead-tip">
          <Col className="pc-infoHead-icon">
            <img src={annIcon} />
            <div> 公告类型：{details.noticeTypeValue}</div>
          </Col>
          <Divider type="vertical" className="pc-infoHead-vertical" />
          <Col className="pc-infoHead-icon">
            <img src={userIcon} />
            <div>
              当前处理人：
              <Popover
                placement="bottom"
                content={
                  <>
                    <div>{details.currentProcessorUserName}</div>
                    <div>电话：{details.currentProcessorUserPhone}</div>
                    <div>邮箱：{details.currentProcessorUserEmail}</div>
                  </>
                }
              >
                <a>{details.currentProcessorUserName}</a>
              </Popover>
            </div>
          </Col>
          <Divider type="vertical" className="pc-infoHead-vertical" />
          <Col className="pc-infoHead-icon">
            <img src={timeIcon} />
            <div>创建时间：{details.createTime}</div>
          </Col>
        </Row>
      </div>
      <div
        className="pc-infoHead-btn"
        style={{ backgroundColor: backgroundColor, color: color }}
      >
        {details.noticeStatusValue}
      </div>
    </div>
  );
  return {
    infoHeadComponent
  };
};
